import React, { useState, useEffect } from 'react';
import { Button, Modal, Spin, Divider, Collapse, Progress } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopyTwoTone } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCrown, faMobileNotch, faPenFancy, faPhone} from '@fortawesome/pro-solid-svg-icons'

import AdsComponent from './AdsComponent';
import uploadFile from '../../../helpers/s3-upload';
import { appendUTMToURL } from '../../../helpers/utmTracking';
import { t } from '../../../i18n';

// import videoFile from '../../../assets/ads/svgtracepro.mov';
import manualservice from '../../../assets/ads/manualservice.png';
// import { set } from 'react-ga';



// import collectData from '../../../helpers/collect-data';
// const uuid = require('uuid');

const { Panel } = Collapse;

const ResultsModal = (props) => {

  const [shareLinkText, setShareLinkText] = useState(t("Click To Create Share Link"));
  const [shareLink, setShareLink] = useState('');
  const [timer, setTimer] = useState(null);
  const [countdown, setCountdown] = useState(30);
  const [downloadComplete, setDownloadComplete] = useState(false);
  const countdownIntervalRef = React.useRef(null);
  const hasDownloadedRef = React.useRef(false);

  const [timerDone, setTimerDone] = useState(false);
  const [skipAd, setSkipAd] = useState(true);
  const [showAd, setShowAd] = useState(-1);

  // Start countdown when modal opens
  useEffect(() => {
    if (!props.isLoading && !downloadComplete) {
      setCountdown(30);
      hasDownloadedRef.current = false;

      countdownIntervalRef.current = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            clearInterval(countdownIntervalRef.current);
            handleOk();
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);

      return () => {
        if (countdownIntervalRef.current) {
          clearInterval(countdownIntervalRef.current);
        }
      };
    }
  }, [props.isLoading]);

  // Reset on unmount
  useEffect(() => {
    return () => {
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, []);


  // make a useEfeect to set the timer for 5 seconds
  useEffect(() => {

    if (timer) {
      clearTimeout(timer);
      // setTimerDone(false);
    }


    // if (Math.random() > 0) {
    //   // setShowAd(1)
    //     setTimer(setTimeout(() => {
    //     console.log('timer done');
    //     setTimerDone(true);
    //   }, 4000));
    //   setSkipAd(true);
    // }

    // if (Math.random() > 0.5) setShowAd(true);
    // else setShowAd(false);

    // if (Math.random() > 0.5) {
    //   setShowAd(1)
    //   setTimer(setTimeout(() => {
    //     console.log('timer done');
    //     setTimerDone(true);
    //   }, 5000));
    // }
    // else {
    //   setShowAd(2);
    //   setTimerDone(true);
    // }
  }, []);

  const handleOk = async function () {

    // Prevent duplicate downloads
    if (hasDownloadedRef.current) {
      return;
    }
    hasDownloadedRef.current = true;

    // // if item from storage doesnt exist, create a new user id
    // if (!JSON.parse(localStorage.getItem('svgTraceUserId'))) {
    //   const userId = uuid.v4()
    //   localStorage.setItem('svgTraceUserId', JSON.stringify(userId))
    // }





    // let deviceType = 'desktop';
    // // if navigator is iphone set device type to iPhone
    // if (navigator.userAgent.match(/iPhone/i) ) deviceType = 'iPhone';
    // else if (navigator.userAgent.match(/Android/i) ) deviceType = 'android';
    // else if (navigator.userAgent.match(/iPad/i) ) deviceType = 'iPad';
    // else if (navigator.userAgent.match(/iPod/i) ) deviceType = 'iPod';
    // else if (navigator.userAgent.match(/BlackBerry/i) ) deviceType = 'blackberry';
    // else if (navigator.userAgent.match(/Windows Phone/i) ) deviceType = 'windows phone';
    // else if (navigator.userAgent.match(/Windows/i) ) deviceType = 'windows';
    // else if (navigator.userAgent.match(/Linux/i) ) deviceType = 'linux';
    // else if (navigator.userAgent.match(/Mac/i) ) deviceType = 'mac';
    // else deviceType = 'other';



    // collectData(blob, `users/${JSON.parse(localStorage.getItem('svgTraceUserId'))}/downloads`, deviceType);

    // get lastConverted from session storage
    // let lastConverted = sessionStorage.getItem('lastConverted');
    // console.log(lastConverted);


    let blob = await fetch(props.downloadSVGLink).then(r => r.blob());
    uploadFile(blob, "svgtrace-downloads-bucket", "svg-converter/",)


    // console.log("link clicked");
    const link = document.createElement('a');
    link.href = props.downloadSVGLink;
    link.setAttribute(
      'download',
      `trace.svg`,
    );
    // Append to html link element page
    document.body.appendChild(link);
    // Start download
    link.click();
    // Clean up and remove the link
    link.parentNode.removeChild(link);
    setDownloadComplete(true);
    // props.setIsModalVisible(false)

  }
  const handleCopy = async function () {
    // if share link doesnt exist, create a new share link
    if (shareLink === '') {
      let blob = await fetch(props.downloadSVGLink).then(r => r.blob());
      const newSharelink = await uploadFile(blob, "svgtrace-upload-results-bucket")
      setShareLink(newSharelink);
      // await navigator.clipboard.writeText(newSharelink);
      setShareLinkText(t("Click to Copy"));
      // return;
    }
    // copy new value to clipboard
    navigator.clipboard.writeText(shareLink);
    setShareLinkText(t("Share Link Copied"));
    // let blob = await fetch(props.downloadSVGLink).then(r => r.blob());
    // collectData(blob, "image-to-svg/share-link-copied");
  }

  // check for state change of sharLink and copy to clipboard
  useEffect(() => {
    if (shareLink !== '') {
      handleCopy();
    }
  }, [shareLink])




  // // make a function that returns two different buttons depending on what the shareLink is
  // const shareLinkButton = () => {
  //   if (shareLink === '') {
  //     return (

  //       <Button>{copied ? 'Share Link Copied ' : 'Share Link '}</Button>

  //     )
  //   } else {
  //     return (
  //       <CopyToClipboard text={shareLink}
  //       onCopy={() => {handleCopy();} }>
  //       <Button icon={<CopyTwoTone/>}>{copied ? 'Share Link Copied ' : 'Share Link '}</Button>
  //     </CopyToClipboard>
  //     )
  //   }
  // }

  // isIOS variable
  const isIOS = () => {
    // make 50/50 chance of returning true or false
    // console.log(Math.random());
    return showAd;

    // // return true if user agent is iphone
    // if (navigator.userAgent.match(/iPhone/i)) return true;
    // else if (navigator.userAgent.match(/iPad/i)) return true;
    // else if (navigator.userAgent.match(/iPod/i)) return true;
    // else return false;
  }

  const handleCancel = () => {
    props.setIsModalVisible(false)
  }

  return (
    // set the max height of the modal to 80% of the screen

    <Modal
    style={{ top: "50px" }}
      title={null}
      open={true}
      onOk={() => { handleOk(); }}
      onCancel={() => { handleCancel(); }}
      footer={null}
      closable={false}
      width={400}

    >
      {/* check to see if the timer is done */}

      {/* make a minimum 5 second ad  or until is loading is finished*/}
      {!(!props.isLoading && skipAd) && false?
        // if the user is on iOS
        // show the ad
        // else show the video
        <div>
          {showAd === 1 &&
            <>
              <h3>Want to edit your SVG?</h3>
         
{/*       
              <video autoPlay={true} playsInline={true} loop={true} style={{ width: "100%" }}>
                <source src={videoFile} type="video/mp4" />
              </video>      */}
              <div style={{ height: "10px" }}></div>

              <Button type="primary" onClick={() => {
                // navigate to https://apps.apple.com/ca/app/svgtrace-pro/id6444320997 in a new tab
                window.open("https://apps.apple.com/app/svgtrace-pro/id6444320997", "_blank")
              }} style={{ width: "100%" }}>
                Download SvgTrace Pro for iOS
              </Button>
            </>
          }
          {showAd  === 2&&
            // make a spacer
            <>
              <h3>Need more help? We will trace any image within 48 hours.</h3>
              {/* <div style={{ height: "30px" }}></div> */}
              <img src={manualservice} style={{
                maxWidth: "70%",
                // center 
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }} />
              <div style={{ height: "20px" }}></div>

              <Button type="primary" onClick={() => {
                // navigate to https://apps.apple.com/ca/app/svgtrace-pro/id6444320997 in a new tab
                window.open("http://192.168.86.238:8080/services/manual-svg-conversion", "_blank")
              }} style={{ width: "100%" }}>
                Learn More
              </Button>

            </>



          }
        </div>

        :
        <div
        // center content
        style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", padding: "0" }}
        >

          {/* if it is loading make a converting message */}
          {props.isLoading &&
            <div style={{ paddingTop: "40px", paddingBottom: "40px",
            display: "flex",
            justifyContent: "center"
            }}>
              <Spin tip={t("Converting...")} size="large" />
            </div>
          }

          {/* Modern Compact Pro Upsell - Only show when not loading */}
          {!props.isLoading && (
            <div style={{
              padding: '24px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '12px',
              boxShadow: '0 6px 20px rgba(102, 126, 234, 0.3)',
              textAlign: 'center',
              width: '100%'
            }}>
            {/* Countdown Circle */}
            {!downloadComplete && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '16px'
              }}>
                <div style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '50%',
                  background: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }}>
                  <svg style={{ position: 'absolute', transform: 'rotate(-90deg)', width: '100%', height: '100%' }}>
                    <circle cx="32" cy="32" r="28" fill="none" stroke="#f0f0f0" strokeWidth="4" />
                    <circle
                      cx="32" cy="32" r="28" fill="none" stroke="url(#gradient-mobile)" strokeWidth="4"
                      strokeLinecap="round" strokeDasharray={`${2 * Math.PI * 28}`}
                      strokeDashoffset={`${2 * Math.PI * 28 * (countdown / 30)}`}
                      style={{ transition: 'stroke-dashoffset 1s linear' }}
                    />
                    <defs>
                      <linearGradient id="gradient-mobile" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#667eea" />
                        <stop offset="100%" stopColor="#764ba2" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <div style={{
                    fontSize: '20px',
                    fontWeight: '800',
                    color: '#667eea',
                    zIndex: 1,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                  }}>
                    {countdown}
                  </div>
                </div>
              </div>
            )}
            
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: 'white',
              marginBottom: '16px',
              textShadow: '0 2px 8px rgba(0,0,0,0.15)',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
            }}>
              {downloadComplete ? t('✓ Download Complete!') : t('Have you tried SVGTrace Pro yet?')}
            </div>
            
            {downloadComplete && (
              <Button 
                onClick={handleOk}
                size="large"
                block
                style={{
                  background: 'rgba(255, 255, 255, 0.25)',
                  backdropFilter: 'blur(10px)',
                  color: 'white',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  fontWeight: '600',
                  height: '48px',
                  fontSize: '14px',
                  borderRadius: '24px',
                  marginBottom: '12px',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                }}
              >
                {t('📥 Download Again')}
              </Button>
            )}
            
            <a href={appendUTMToURL('https://pro.svgtrace.com/signup', 'results-modal-cta')} target="_blank" rel="noopener noreferrer">
              <Button 
                type="default"
                size="large"
                block
                style={{
                  background: 'white',
                  border: 'none',
                  fontWeight: '700',
                  height: '48px',
                  fontSize: '15px',
                  borderRadius: '24px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                <span style={{ fontSize: '16px' }}>🎉</span>
                <span style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  fontWeight: '700'
                }}>
                  {t("Try Pro for Free")}
                </span>
              </Button>
            </a>
            
            <div style={{
              marginTop: '12px',
              fontSize: '12px',
              color: 'rgba(255,255,255,0.9)',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
            }}>
              {t("Instant downloads • AI tools • Full editor")}
            </div>
          </div>
          )}
          {/* </Spin> */}
        </div>


      }


    </Modal>
  );
};

export default ResultsModal;
